module.exports = __webpack_public_path__ + "static/media/sucursales.dfbdbfe6.png";